module.exports = __webpack_public_path__ + "img/Carousel_Header_LMS.52dac3b9.png";